export enum ConnectionStateEnum {
  Connected = 0,
  Disconnected = 1,
  Delayed = 2,
}
